var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyState = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 150,
    viewBox: "0 0 201 150",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17252_256958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.5 130.645C134.435 130.645 161.946 103.077 161.946 68.9514C161.946 34.8256 134.314 7.25781 100.5 7.25781C66.5659 7.25781 39.0547 34.8256 39.0547 68.9514C39.0547 103.077 66.5659 130.645 100.5 130.645Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.659 28.1088C159.387 28.1088 161.598 25.8883 161.598 23.1491C161.598 20.41 159.387 18.1895 156.659 18.1895C153.93 18.1895 151.719 20.41 151.719 23.1491C151.719 25.8883 153.93 28.1088 156.659 28.1088Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.889 8.75466C165.752 8.75466 167.263 7.23821 167.263 5.36757C167.263 3.49692 165.752 1.98047 163.889 1.98047C162.026 1.98047 160.516 3.49692 160.516 5.36757C160.516 7.23821 162.026 8.75466 163.889 8.75466Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7172 27.9881C43.5804 27.9881 45.0907 26.4716 45.0907 24.601C45.0907 22.7303 43.5804 21.2139 41.7172 21.2139C39.8541 21.2139 38.3438 22.7303 38.3438 24.601C38.3438 26.4716 39.8541 27.9881 41.7172 27.9881Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1166 93.3111C24.5767 93.3111 27.3817 90.4948 27.3817 87.0208C27.3817 83.5467 24.5767 80.7305 21.1166 80.7305C17.6565 80.7305 14.8516 83.5467 14.8516 87.0208C14.8516 90.4948 17.6565 93.3111 21.1166 93.3111Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5108 95.7751L97.3759 95.7437C96.9489 95.7374 96.5273 95.3028 96.5591 94.7741C96.5909 94.2454 96.9232 93.7967 97.3502 93.803L99.4851 93.8344C99.9121 93.8407 100.334 94.2753 100.302 94.804C100.244 95.4331 99.9378 95.7814 99.5108 95.7751Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17252_256958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.8415 39.2898L115.73 92.659C116.595 94.508 115.831 96.6577 113.99 97.526L61.79 122.277C59.9492 123.145 57.8084 122.377 56.9432 120.528L24.4922 51.4545C23.6269 49.6054 24.3908 47.4558 26.2317 46.5875L64.0105 28.7269L89.8415 39.2898Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.0234 28.7129L70.9553 43.5225C71.9612 45.5597 74.5463 46.4599 76.5702 45.4528L89.8519 39.3067",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17252_256958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.698 44.6703L136.53 103.974C136.53 106.015 134.927 107.629 132.891 107.623L75.0973 107.581C73.0611 107.576 71.4468 105.964 71.4467 103.923L71.3256 27.6213C71.3254 25.5803 72.929 23.9666 74.9651 23.9722L116.77 24.0495L135.698 44.6703Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.805 23.998L116.792 40.3314C116.838 42.6006 118.798 44.519 121.059 44.4757L135.703 44.6093",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_17252_256958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.071 71.0187L147.985 125.176C147.184 127.003 144.936 127.8 143.136 126.89L90.719 102.6C88.8929 101.791 88.0901 99.5357 88.8916 97.7086L120.677 28.5263C121.478 26.6993 123.726 25.9023 125.525 26.8119L163.588 44.4812L172.071 71.0187Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.486 44.3816L156.689 59.2272C155.707 61.3298 156.757 63.8658 158.856 64.8547L172.052 70.9483",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17252_256958",
    x: 0.136719,
    y: 12.7268,
    width: 139.949,
    height: 141.906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17252_256958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17252_256958",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17252_256958",
    x: 47.3242,
    y: 7.97217,
    width: 113.207,
    height: 131.651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17252_256958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17252_256958",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_17252_256958",
    x: 64.582,
    y: 10.4343,
    width: 131.488,
    height: 148.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.247059 0 0 0 0 0.631373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17252_256958"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17252_256958",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17252_256958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 150,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyState, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-state.533c98ab.svg";
export { ForwardRef as ReactComponent };